import React from "react"
import styled from "styled-components"

import { Container, Row, Col } from "../Grid"
import Link from "../Link"
import Button from "../Button"
import Snippet from "../Snippet"

import heroIllustration from "../../images/content/careers/hero.svg"

import { media, mixins } from "../../styles"

const Wrapper = styled.div`
  background: var(--color-greyLight);
  margin: 0 0 16px;
  padding: 50px 10px;

  @media ${media.md} {
    margin: 0 0 25px;
  }

  @media ${media.lg} {
    margin: 0 0 30px;
    padding: 70px 10px 10px;
  }

  @media ${media.xl} {
    margin: 0 0 40px;
    padding: 95px 10px 10px;
  }
`

const Header = styled.div`
  margin: 0 0 50px;
  text-align: center;

  @media ${media.lg} {
    padding: 0 20px;
  }

  @media ${media.xl} {
    margin: 0 0 50px;
    padding: 0 60px;
  }

  h1 {
    ${mixins.title2}
    margin: 0 0 20px;

    @media ${media.xl} {
      margin: 0 0 40px;
    }
  }

  p {
    ${mixins.copy2}
  }
`

const SubHeader = styled.h2`
  ${mixins.title5}
  line-height: 1;
  margin: 0 0 10px;

  @media ${media.lg} {
    margin: 0 0 15px;
  }

  @media ${media.xl} {
    margin: 0 0 5px;
  }
`

const ButtonRow = styled.div`
  padding: 5px 0 0;
`

const Illustration = styled.div`
  margin: 0 auto -66px;
  max-width: 320px;

  @media ${media.md} {
    max-width: 100%;
    margin: 0 auto -75px;
    width: 500px;
  }

  @media ${media.lg} {
    margin: 0 auto -40px;
    width: 600px;
  }

  @media ${media.xl} {
    margin: 0 auto -50px;
    width: 800px;
  }

  img {
    display: block;
    height: auto;
    max-width: 100%;
  }
`

const CareersHero = ({ showButton }) => {
  return (
    <Container>
      <Wrapper>
        <Row>
          <Col md="10" mdOffset="1" lg="10" lgOffset="1">
            <Header>
              <SubHeader>
                {Snippet({ id: "careersHeroSubheader", field: "header" })}
              </SubHeader>
              <h1>{Snippet({ id: "careersHero", field: "header" })}</h1>
              {showButton ? (
                <ButtonRow>
                  <Button as={Link} arrow to="#jobs">
                    {Snippet({ id: "careersHero", field: "linkText" })}
                  </Button>
                </ButtonRow>
              ) : null}
            </Header>
          </Col>
        </Row>
        <Illustration>
          <img
            src={heroIllustration}
            alt=""
            aria-hidden="true"
            width="800"
            height="304"
          />
        </Illustration>
      </Wrapper>
    </Container>
  )
}

export default CareersHero
